import { render, staticRenderFns } from "./MappedLabelingPointsList.vue?vue&type=template&id=6b80a78c&scoped=true"
import script from "./MappedLabelingPointsList.vue?vue&type=script&lang=js"
export * from "./MappedLabelingPointsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b80a78c",
  null
  
)

export default component.exports